import { createEffect, sample } from 'effector';
import { createGate } from 'effector-react';
import { createQuery } from '@farfetched/core';
import { getInvoiceStatus } from './api';
import type { GetInvoiceStatusResponse } from './types';

export const InvoiceStatusControlGate = createGate();

const fxGetInvoiceStatus = createEffect<void, GetInvoiceStatusResponse, Error>().use(
  getInvoiceStatus
);

export const invoiceStatusQuery = createQuery({
  name: 'invoice-status',
  effect: fxGetInvoiceStatus,
  mapData: ({ result }) =>
    Array.isArray(result?.invoice_statuses)
      ? result.invoice_statuses.map((item) => ({
          id: item?.name,
          label: item?.title,
        }))
      : [],
});

sample({
  clock: InvoiceStatusControlGate.open,
  source: InvoiceStatusControlGate.status,
  filter: (status) => Boolean(status),
  target: invoiceStatusQuery.start,
});
